import React, { useEffect, useState } from "react";
import style from "./dashboard.module.scss";
import Skeleton from "../skeleton/skeleton"

const DashBoardSkeleton = (props) => {

    return <div>
        <div className={style.row}>
            <div className={style.bigCard} style={{ background: 'none' }}>
                <h2><Skeleton type='rectangle' width='100px' height='40px' /></h2>

                <div className={style.canvasWrapper}>
                    <Skeleton type='rectangle' width='100%' height='300px' />
                </div>
                <div className={style.totalCost}>
                    <Skeleton type='rectangle' width='100%' height='30px' />
                </div>
            </div>
            <div className={style.bigCard} style={{ background: 'none' }}>
                <h2><Skeleton type='rectangle' width='100px' height='40px' /></h2>

                <div className={style.canvasWrapper}>
                    <Skeleton type='rectangle' width='100%' height='300px' />
                </div>
                <div className={style.totalCost}>
                    <Skeleton type='rectangle' width='100%' height='30px' />
                </div>
            </div>
        </div>
        <div style={{ marginTop: '15px' }}>
            <Skeleton type='rectangle' width='100%' height='30px' />
        </div>
    </div>
}
export default DashBoardSkeleton;
